export default function swiperjs() {
  /**
   * Swiper
   */
  (function ($) {
    // トップページじゃなければ処理をしない
    if (!$('body').hasClass('home')) return;

    const swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.productSlider--next',
        prevEl: '.productSlider--prev',
      },
    });
  })(jQuery);
}
